import { useIsBootstrapping } from '../../contexts/SiteContext';
import { PageSkeleton } from '../skeleton/PageSkeleton';

export function SiteBootstrapGate({ children }: { children: React.ReactNode }) {
  const isBootstrapping = useIsBootstrapping();
  if (isBootstrapping) return <PageSkeleton />;
  return <>{children}</>;
}
